import { PrescriptionType } from '../../services/timeline-service';

interface ParamsProps {
  buttonName?: string;
  dosePrescriptionQuantity?: number;
  doseQuantity?: string | null;
  doseUnitMeasureCode?: string | null;
  eventDate?: string;
  hourSequence?: string;
  itemCode?: string;
  itemType?: PrescriptionType;
  medicationName?: string;
  prescriptionNumber?: string;
}

interface ParamButtonNameProps {
  buttonName?: string;
}

interface ChemotherapyMedicationsProps {
  encounterIdSequence: number;
  groupingNumber: number;
  isAdministered: string;
  isApplication?: string;
  isChemotherapy?: boolean;
  isMedication?: string;
  isType?: string;
  isUrgency: string;
  materialSequence: number;
  orderSequence: number;
  prescriptionNumber: number;
}

interface PatientInfosProps {
  patientInfos?: unknown;
}

interface AdminScheduleProps {
  dilutionDescription: string | null;
  dosePrescriptionQuantity?: number;
  materialSequence?: number;
  medicationHour?: string;
  pdoPrn?: boolean;
  prescriptionNumber?: number;
}

export class MedicationViewerParams {
  static params: ParamsProps;
  static paramButton: ParamButtonNameProps;
  static infos: PatientInfosProps;
  static adminSchedule: AdminScheduleProps;
  static chemotherapy: ChemotherapyMedicationsProps;
}